import React from 'react';
import { formatAsMoney } from '@perch-labs/warbler';
import { copyFor } from 'config';
import Savings from '/images/dashboard-page/savings.svg';
import { Container } from 'styles';
import { StyledModule } from '../styled-module';
import { ModuleContainer } from '../impact-modules.style';
import { StyledSVG, StyledText } from './solar-savings.style';

const getCopy = copyFor(
  'dashboard.standardDashboard.impactModules.solarSavings'
);
interface Props {
  vnmSavingsCumulativeCents?: number;
  vnmSavingsLastStatementCents?: number;
}

export const SolarSavings = ({
  vnmSavingsCumulativeCents,
  vnmSavingsLastStatementCents,
}: Props) => {
  const placeHolder = !vnmSavingsCumulativeCents;
  const text = getCopy('emptyState');
  return !placeHolder ? (
    <StyledModule
      showBadge={!!vnmSavingsLastStatementCents}
      title={getCopy('title')}
      tooltipProps={{
        content: getCopy('tooltip.content'),
        label: getCopy('tooltip.label'),
        tooltipId: 'LifetimeSolarSavings',
      }}
      // TODO remove undefined handling here after release
      boldCopy={formatAsMoney(vnmSavingsCumulativeCents || 0, {
        conversion: 'fromCents',
      })}
      svgSrc={Savings}
      badgeCopy={getCopy('badge', {
        savings: formatAsMoney(vnmSavingsLastStatementCents || 0, {
          conversion: 'fromCents',
        }),
      })}
    />
  ) : (
    <ModuleContainer>
      <Container
        height="100%"
        flex
        justifyContent="space-between"
        alignItems="center"
        small={{
          alignItems: 'flex-start',
          direction: 'column-reverse',
          justifyContent: 'start',
          gap: '10px',
        }}
      >
        <StyledText color="secondary" textStyle="paragraph400">
          {text}
        </StyledText>
        <StyledSVG src={Savings} aria-hidden={true} />
      </Container>
    </ModuleContainer>
  );
};
